import { useEffect, useRef, useState } from "react";

// animate.css entrance/exit animations run ~1s by default; give the exit
// animation this long to actually play before the element unmounts.
export const EXIT_ANIMATION_DURATION_MS = 1000;

export const useAnimate = (element, timerOnDoc, visible) => {
  const [animateClass, setAnimateClass] = useState({
    animationName: element?.value?.animation || "",
    infinite: "",
  });
  const wasVisible = useRef(visible);

  useEffect(() => {
    if (timerOnDoc || !element?.value?.animation) return;

    if (visible) {
      setAnimateClass({
        animationName: element?.value?.animation,
        infinite: element?.value?.frequency === "loopAnimation" ? "infinite" : "",
      });
    } else if (wasVisible.current && element?.value?.disappear) {
      setAnimateClass({
        animationName: element?.value?.disappear,
        infinite: "",
      });
    }
    wasVisible.current = visible;
  }, [
    visible,
    timerOnDoc,
    element?.value?.animation,
    element?.value?.disappear,
    element?.value?.frequency,
  ]);

  const iterationCount =
    element?.value?.frequency === "loop5Seconds"
      ? 5
      : element?.value?.frequency === "loop10Seconds"
        ? 10
        : element?.value?.frequency === "loopAnimation"
          ? "infinite"
          : 1;

  return { animateClass, iterationCount };
};
